import { useState } from "react";

import "./sectioncard.css";

export default function SectionCard({
  title,
  description = "",
  icon = null,
  children,
  defaultOpen = true,
  rightActions = null,
  className = "",
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      className={`job-section-card ${
        open ? "open" : "collapsed"
      } ${className}`}
    >
      <div className="job-section-header">
        <button
          type="button"
          className="job-section-toggle"
          onClick={() =>
            setOpen((previous) => !previous)
          }
          aria-expanded={open}
        >
          <div className="job-section-header-main">
            {icon && (
              <div
                className="job-section-icon"
                aria-hidden="true"
              >
                {icon}
              </div>
            )}

            <div className="job-section-heading">
              <h2>{title}</h2>

              {description && (
                <p>{description}</p>
              )}
            </div>
          </div>

          <span
            className={`job-section-chevron ${
              open ? "open" : ""
            }`}
            aria-hidden="true"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>

        {rightActions && (
          <div className="job-section-actions">
            {rightActions}
          </div>
        )}
      </div>

      {open && (
        <div className="job-section-body">
          {children}
        </div>
      )}
    </section>
  );
}